import {useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const fields = [
  {name: 'name', label: 'Parent or guardian name', type: 'text', autoComplete: 'name'},
  {name: 'phone', label: 'Phone number', type: 'tel', autoComplete: 'tel'},
  {name: 'email', label: 'Email address', type: 'email', autoComplete: 'email'}
];

const contactDetails = [
  {
    icon: FiIcons.FiMapPin,
    title: 'Address',
    value: '120A Marikkar Street, Dharga Town 12090, Sri Lanka'
  },
  {
    icon: FiIcons.FiPhone,
    title: 'Telephone',
    value: '070 404 9404',
    href: 'tel:0704049404'
  },
  {
    icon: FiIcons.FiMail,
    title: 'Email',
    value: 'admin@minrosecdc.com',
    href: 'mailto:admin@minrosecdc.com'
  },
  {
    icon: FiIcons.FiMessageCircle,
    title: 'WhatsApp',
    value: '+94 70 404 9404',
    href: 'https://wa.me/94704049404'
  }
];

export default function Contact() {
  const [values, setValues] = useState({name: '', phone: '', email: '', age: '', message: ''});
  const [errors, setErrors] = useState({});
  const [notice, setNotice] = useState('');

  const change = (event) => {
    setValues({...values, [event.target.name]: event.target.value});
  };

  const submit = (event) => {
    event.preventDefault();
    const next = {};

    if (!values.name.trim()) next.name = 'Please enter your name.';
    if (!values.phone.trim()) next.phone = 'Please enter your phone number.';
    else if (!/^[+()\d\s-]{7,20}$/.test(values.phone.trim())) next.phone = 'Please enter a valid phone number.';
    if (!values.email.trim()) next.email = 'Please enter your email address.';
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email.trim())) next.email = 'Please enter a valid email address.';
    if (!values.message.trim()) next.message = 'Please enter your enquiry.';

    setErrors(next);
    setNotice(
      Object.keys(next).length
        ? 'Please correct the highlighted fields.'
        : 'Your enquiry has not been sent. Online submissions will be available once a form service is connected. Please contact Minrose using the details shown.'
    );
  };

  return (
    <section className="section contact" id="contact">
      <div className="container contact-grid">
        <div className="contact-intro">
          <h2>Let's Take the Next Little Step Together.</h2>
          <p>Have questions or want to learn more about Minrose Child Development Center? We'd love to hear from you.</p>
        </div>

        <div className="form-column">
          <form onSubmit={submit} noValidate aria-label="Enquiry form">
            <div className="field-grid">
              {fields.map((field) => (
                <div className="field" key={field.name}>
                  <label htmlFor={field.name}>{field.label} <span aria-hidden="true">*</span></label>
                  <input
                    id={field.name}
                    name={field.name}
                    type={field.type}
                    autoComplete={field.autoComplete}
                    required
                    value={values[field.name]}
                    onChange={change}
                    aria-invalid={!!errors[field.name]}
                    aria-describedby={errors[field.name] ? `${field.name}-error` : undefined}
                  />
                  {errors[field.name] && <small id={`${field.name}-error`} role="alert">{errors[field.name]}</small>}
                </div>
              ))}
              <div className="field">
                <label htmlFor="age">Child's age range <span className="optional">(optional)</span></label>
                <select id="age" name="age" value={values.age} onChange={change}>
                  <option value="">Select age range</option>
                  <option>Under 2</option>
                  <option>2–3 years</option>
                  <option>4–5 years</option>
                  <option>6+ years</option>
                </select>
              </div>
            </div>

            <div className="field">
              <label htmlFor="message">Your message or enquiry <span aria-hidden="true">*</span></label>
              <textarea
                id="message"
                name="message"
                rows="4"
                required
                value={values.message}
                onChange={change}
                aria-invalid={!!errors.message}
                aria-describedby={errors.message ? 'message-error' : undefined}
                placeholder="Tell us how we can help..."
              />
              {errors.message && <small id="message-error" role="alert">{errors.message}</small>}
            </div>

            <button className="button button-dark" type="submit">Send an Enquiry <span aria-hidden="true">→</span></button>
            {notice && <p className="form-notice" role="status">{notice}</p>}
          </form>
          <div data-greta-form-placeholder="minrose-enquiry">This form is not collecting yet.</div>
        </div>

        <aside className="contact-card">
          <h3>Contact Information</h3>
          {contactDetails.map(({icon, title, value, href}) => (
            <div className="contact-item" key={title}>
              <SafeIcon icon={icon} aria-hidden="true" />
              <div>
                <strong>{title}</strong>
                {href ? <a href={href}>{value}</a> : <span>{value}</span>}
              </div>
            </div>
          ))}
        </aside>
      </div>
    </section>
  );
}